<template>
    <div
        class="modal fade"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="hideModal(`#${id}`)" data-dismiss="modal" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <h4>Edit Family Name</h4>
                    <form class="row gy-1 mt-1">
                        <div class="col-12" >
                            <input type="text" class="form-control" name="familyName" id="familyName" v-model="familyName">
                        </div>
                        <div class="col-12 d-flex justify-content-end">
                            <button type="reset" class="btn btn-outline-secondary mt-1 me-1 waves-effect mr-1" data-dismiss="modal" aria-label="Close">
                                Cancel
                            </button>
                            <button type="button" class="btn btn-primary mt-1 waves-effect waves-float waves-light d-flex align-items-center" v-on:click="editFamily">
                                <span class="me-50">Edit Family Name</span>
                                <vue-feather type="chevron-right" size="14" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useFamilyStore } from '../../stores/FamilyStore.js'
import { ref } from 'vue';
import { hideModal } from '../../utilities/_helpers'
export default{
    props: {
        id: String,
    },
    setup(){
        return {
            familyStore: useFamilyStore(),
            familyName: ref(null),
            hideModal: hideModal
        }
    },
    methods:{
        editFamily() {
            const $this = this;
            if(this.familyName != ""){
                const route = $this.$router.resolve(
                    {
                        name: 'family-edit',
                        params: {
                            family: $this.familyStore.family.family.id
                        }
                    }
                );
                axios.get(
                    route.href,
                    {
                        params: {
                            name: $this.familyName
                        }
                    }
                ).then(({data})=>{
                    if(data.error != true){
                        toastr.success(`${data.message}`,'Update Success');
                        $this.familyName="";
                        $this.hideModal(`#${$this.id}`);
                        $this.familyStore.fetchFamily();
                    }else{
                        return toastr.error(`${data.message}`,'update Error');
                    }
                }).catch(error=>{
                    let errors = this.getError(error)
                    for (const key in errors) {
                        if (Object.hasOwnProperty.call(errors, key)) {
                            const element = errors[key];
                            return toastr.error(`${element}`,'Invite Error');
                        }
                    }
                })
            }
        },
    }
}
</script>
